import AboutMe from "../About/AboutMe";
import Stack from "../About/Stack";

const AboutPreview = () => {
  return (
    <article className="about">
      <AboutMe />
      <Stack />
    </article>
  );
};

export default AboutPreview;
